module.exports = "/_next/static/images/equity_research_desktop-6402bbad7db56e6140124b1c10d91121.jpg";